export * from "./userEvents";

export const DISTANCE_PREFERENCE_MAX_VALUE_IN_MILES = 150;

export const STATE_LICENSE_REQUIREMENT_ID = "5be9750b06c86c0004a1deca";

export enum SEARCH_MODE {
  CALENDAR = "CALENDAR",
  DATE = "DATE",
  TIME_SLOT = "TIME_SLOT",
  MAP = "MAP",
  HCF_PROFILE = "HCF_PROFILE",
  URGENT_SHIFTS = "URGENT_SHIFTS",
  NEGOTIATING_SHIFTS = "NEGOTIATING_SHIFTS",
  NON_QFA_RANGE_SHIFTS = "NON_QFA_RANGE_SHIFTS",
  WORKER_AVAILABILITY = "WORKER_AVAILABILITY",
}

export const HCF_PROFILE_SOURCE = {
  CALENDAR: "CALENDAR",
  MAP: "MAP",
  PERMANENT_PLACEMENTS_WORK_TRIALS: "PERMANENT_PLACEMENTS_WORK_TRIALS",
  WORKER_AVAILABILITY: SEARCH_MODE.WORKER_AVAILABILITY,
};

export const FACILITY_OPEN_SHIFTS_DATE_RANGE_DAYS = 30;

export const REFERRALS = {
  REFER_A_FRIEND: "Refer a Friend",
  REFER_AND_EARN: "Refer & Earn",
};
